import { useStablePrice } from "./hooks/useStablePrice";
import { useTranslation } from "react-i18next";
import Table from "../Invoices/Table/Table";
import { StablePriceResponse } from "./types/stablePrice";
import { Stack, Typography } from "@mui/material";

const StablePrice = () => {

  const { t, i18n } = useTranslation();

  const {
    data,
    error,
    isError,
    isPending,
    isSuccess
  } = useStablePrice();

  const columns = [
    {
      key: "month", 
      title: t("common:text.stable_price.month"), 
      computeValue: (val: StablePriceResponse[number]) => val[0]
    },
    {
      key: "volume", 
      title: t("common:text.stable_price.volume"), 
      computeValue: (val: StablePriceResponse[number]) => val[1].toLocaleString(i18n.language)
    },
    {
      key: "price", 
      title: t("common:text.stable_price.price"), 
      computeValue: (val: StablePriceResponse[number]) => val[2].toLocaleString(i18n.language)
    }
  ]

  return <Stack direction="column" spacing={2}>
    <Typography variant="h4">
      {t("common:text.stable_price.title")}
    </Typography>
    {<Table 
      data={isSuccess ? data : []} 
      columns={columns} 
      loaded={!isPending}
      onRowStatus={null}
    />}
    {!isPending && <>
      {isError && <div>{t("common:error.crash_view_message")} {error.message}</div>}
    </>}
  </Stack>
}

export default StablePrice;